import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayRange',
    pure: true,
    standalone: true
})
export class ArrayRangePipe implements PipeTransform {
    transform(value: number, ..._args: unknown[]): number[] {
        return Array.from({ length: value }, (_, i) => i);
    }
}
